import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const router = new Router({
	routes: [
		// {
		//   path: '/',
		//   name: 'home',
		// 	component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
		// },
		{
			path: '/',
			redirect: '/inviteParentsToClass',
		},
		{
			path: '/inviteParentsToClass',
			name: 'inviteParentsToClass',
			component: () => import(/* webpackChunkName: "inviteParentsToClass" */ '@/views/inviteParentsToClass')
		},
		{
			path: '/relativesAndFriendsRegister',
			name: 'relativesAndFriendsRegister',
			component: () => import(/* webpackChunkName: "relativesAndFriendsRegister" */ '@/views/relativesAndFriendsRegister')
		}
	]
})
export default router